module.exports = __webpack_public_path__ + "static/img/coming_soon.8afa94e5.png";